module.exports = __webpack_public_path__ + "img/mk-bg-01.cca9a6b0.png";